// @ts-ignore
import FormWizard from "react-form-wizard-component";
import "react-form-wizard-component/dist/style.css";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import BookingInformation from "./components/multistep/BookingInformation";
import PassportInformation from "./components/multistep/PassportInformation";
import PaymentInformation from "./components/multistep/PaymentInformation";
import DigitalRoomKey from "./components/multistep/DigitalRoomKey";
import ThankYou from "./components/multistep/ThankYou";
import { AuthorizationResponsePayload } from "@sphereon/ssi-sdk.siopv2-oid4vp-common";
import { CredentialMapper } from "@sphereon/ssi-types";
import GuestInformation from "./components/multistep/GuestInformation";
import PersonalizedPreCheckinExperience from "./components/multistep/PersonalizedPreCheckinExperience";

type PreCheckInWizardProps = {
  payload: AuthorizationResponsePayload;
  onApply?: () => void;
};

const PreCheckInWizard: React.FC<PreCheckInWizardProps> = (props:PreCheckInWizardProps) => {
  const navigate = useNavigate();

  const [activeStep, setActiveStep] = useState(0);
  const [mounted, setMounted] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  const getSubjects = (payload: AuthorizationResponsePayload, index: number = 0) => {
    if (payload) {
      const presentation = CredentialMapper.toWrappedVerifiablePresentation(
        Array.isArray(payload.vp_token)
          ? payload.vp_token[0]
          : payload.vp_token!,
      );
      const subjects =
        presentation?.presentation?.verifiableCredential[index].credential
          .credentialSubject!; // Although rare, a VC can have more than one subject
      return subjects;
    }
    return null;
  }

  useEffect(() => {
    if (window.location.hash.startsWith("#payment")) {
      setActiveStep(4);
      setMounted(true);
      setTermsAccepted(false);
    } else {
      setMounted(true);
      setTermsAccepted(false);
    }

    return () => {
      setActiveStep(0);
      setMounted(false);
    };
  }, []);

  const handleComplete = () => {
    console.log("Form completed!");
    // Handle form completion logic here
    let path = `/hotel`;
    navigate(path);
  };

  const tabChanged = ({
    prevIndex,
    nextIndex,
  }: {
    prevIndex: number;
    nextIndex: number;
  }) => {};

  const updateTermsAccepted = (checked: boolean) => {
    setTermsAccepted(checked);
  };

  const checkValidateTab = () => {
    return termsAccepted;
  };

  if (mounted) {
    let fullName = "";
    if (props.payload)
      fullName = (getSubjects(props.payload) as any)?.firstName + " " + (getSubjects(props.payload) as any)?.lastName;  
    else
      fullName= "Bogdan Mocanu";
    return (
      <FormWizard
        color={"#aa8453"}
        onComplete={handleComplete}
        onTabChange={tabChanged}
        startIndex={activeStep}
      >
        <FormWizard.TabContent title="Guest Information">
          <GuestInformation />
        </FormWizard.TabContent>
        <FormWizard.TabContent title="Digital Room Key">
          <DigitalRoomKey fullName={fullName}/>
        </FormWizard.TabContent>
      </FormWizard>
    );
  }

  return null;
};

export default PreCheckInWizard;
